import React from 'react';
import { LocationIcon } from './icons';

export interface LandingMiniCardProps {
    type: 'technology' | 'researcher';
    title: string;
    location: string;
    detail: string;
    relevanceScore: number | string;
    onReadMore: () => void;
}

export const LandingMiniCard: React.FC<LandingMiniCardProps> = ({
    type,
    title,
    location,
    detail,
    relevanceScore,
    onReadMore
}) => {
    const isResearcher = type === 'researcher';

    return (
        <div className="flex w-full sm:w-[220px] sm:h-[260px] p-3 flex-col items-start rounded-xl border-[0.5px] border-primary-100 shadow-custom-light relative">
            
            <div className="flex flex-col items-start gap-2 self-stretch w-full min-w-0">
                <div className="flex w-full py-1 px-2 sm:px-3 justify-center items-center rounded-[56px] bg-primary-100 min-w-0">
                    <span className="text-primary-og-600 font-grotesk text-[10px] sm:text-xs text-center whitespace-nowrap flex-shrink-0">
                        {typeof relevanceScore === 'number' ? `${relevanceScore}% relevance score` : relevanceScore}
                    </span>
                </div>
                <div className="flex flex-col items-start gap-1 self-stretch">
                    <h4 
                        className="self-stretch text-grayscale-1300 font-grotesk text-base font-medium leading-tight"
                    >{title}</h4>
                    <div className="flex items-center gap-1 self-stretch">
                        <LocationIcon />
                        <span className="text-grayscale-1000 font-grotesk text-xs">{location}</span>
                    </div>
                </div>
            </div>

            <div className="w-full mt-auto">
                <hr className="border-t border-primary-300 my-2" />
                {isResearcher ? (
                    <div className="flex items-center gap-2 self-stretch">
                        <button 
                            onClick={onReadMore} 
                            className="flex h-7 py-2 px-2 justify-center items-center gap-1 flex-1 rounded-[19px] border border-primary-200"
                        >
                            <span className="text-grayscale-1300 font-grotesk text-sm font-medium">{detail}</span>
                        </button>
                    </div>
                ) : (
                    <div>
                        <div className="flex justify-between items-center">
                            <span className="text-grayscale-1300 font-grotesk text-sm font-medium">{detail}</span>
                        </div>
                        <hr className="border-t border-primary-300 mt-1 mb-3" />
                        <div className="flex items-center gap-2 self-stretch">
                            <button 
                                onClick={onReadMore} 
                                className="flex h-7 py-2 px-2 justify-center items-center gap-1 flex-1 rounded-[19px] border border-primary-200"
                            >
                                <span className="text-grayscale-1300 font-grotesk text-sm font-medium">Read More</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
